





























import Vue from "vue";
import { mapGetters } from "vuex";

export default Vue.extend({
  name: "profile",
  computed: {
    ...mapGetters("users", ["fullName", "isAuthenticated", "avatarUrl"]),
    email() {
      return this.$store.state.users.user.email;
    }
  },
  methods: {
    async logOut() {
      await this.$store.dispatch("users/logOut");
      await this.$router.push("Auth");
    }
  }
});
